import dayjs from 'dayjs'

export function formatDateTime(seconds: number) {
  return dayjs.unix(seconds).format('YYYY-MM-DD HH:mm:ss')
}

// result template: 2022-12-30 15:23:40 (UTC+08:00)
export function formatDateTimeWithTz(seconds: number) {
  return dayjs.unix(seconds).format('YYYY-MM-DD HH:mm:ss (UTCZ)')
}

// result template: UTC+08:00
export function getLocalTzStr() {
  return dayjs().format('UTCZ')
}
